(function () {
  function bindTypeToggles(root) {
    var groups = root.querySelectorAll('[data-ll-trade-types]');
    groups.forEach(function (group) {
      var labels = group.querySelectorAll('.ll-trade-form__type');
      labels.forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;

        function sync() {
          labels.forEach(function (item) {
            var radio = item.querySelector('input');
            item.classList.toggle('is-active', !!(radio && radio.checked));
          });
        }

        input.addEventListener('change', sync);
        sync();
      });
    });
  }

  function init() {
    document.querySelectorAll('.ll-trade-form').forEach(bindTypeToggles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
